import { render, staticRenderFns } from "./AdvantagesTable.vue?vue&type=template&id=5548bc88&scoped=true"
import script from "./AdvantagesTable.vue?vue&type=script&lang=ts"
export * from "./AdvantagesTable.vue?vue&type=script&lang=ts"
import style0 from "./AdvantagesTable.vue?vue&type=style&index=0&id=5548bc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548bc88",
  null
  
)

export default component.exports